function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 16a8 8 0 10-8-8 8.01 8.01 0 008 8zM4.529 6.86l3-3c.26-.26.682-.26.942 0l3 3a.667.667 0 11-.942.943L8.95 6.225a.167.167 0 00-.284.118V12a.667.667 0 01-1.334 0V6.343a.166.166 0 00-.284-.118L5.47 7.803a.664.664 0 01-1.124-.294.664.664 0 01.182-.648z"
});

function SvgHappyBackToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgHappyBackToTop;